"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getNumberFromUnknown_1 = __importDefault(require("../../shared/getNumberFromUnknown"));
const valueIsNullOrUndef_1 = __importDefault(require("../../typeAssertions/valueIsNullOrUndef"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const arithmeticOperation = ({ functionId, entryVars: { a: entryA, b: entryB, c: entryC, operator, moreOperators, }, callbacks, executeProcesses, processor, }) => {
    try {
        /* Validate that the operands are not empty */
        const a = (0, getNumberFromUnknown_1.default)(entryA || 0);
        const b = (0, getNumberFromUnknown_1.default)(entryB || 0);
        let newEntryValues = [];
        if ((0, valueIsRecord_1.default)(moreOperators)) {
            newEntryValues = Object.entries(moreOperators)
                .reduce((acum, [key, value]) => {
                if ((0, valueIsNullOrUndef_1.default)(value)) {
                    return acum;
                }
                try {
                    const newAccum = [
                        ...acum,
                        (0, getNumberFromUnknown_1.default)(value),
                    ];
                    return newAccum;
                }
                catch (_a) {
                    throw new Error(`Invalid extra value: key[${key}], value: [${value}]`);
                }
            }, []);
        }
        /* Determine and execute operation */
        const result = () => {
            switch (operator) {
                case '+': {
                    const c = (0, getNumberFromUnknown_1.default)(entryC || 0);
                    const entryResult = [a, b, c, ...newEntryValues]
                        .reduce((acum, value) => acum + value, 0);
                    return entryResult;
                }
                case '-': {
                    const c = (0, getNumberFromUnknown_1.default)(entryC || 0);
                    const entryResult = [a, b, c, ...newEntryValues]
                        .reduce((acum, value, index) => {
                        if (index === 0) {
                            return value;
                        }
                        return acum - value;
                    }, 0);
                    return entryResult;
                }
                case '*': {
                    if (entryC) {
                        const c = (0, getNumberFromUnknown_1.default)(entryC);
                        const entryResult = newEntryValues
                            .reduce((acum, value, index) => {
                            if (index === 0 && acum === 0) {
                                return value;
                            }
                            return acum * value;
                        }, a * b * c);
                        return entryResult;
                    }
                    const entryResult = newEntryValues
                        .reduce((acum, value, index) => {
                        if (index === 0 && acum === 0) {
                            return value;
                        }
                        return acum * value;
                    }, a * b);
                    return entryResult;
                }
                case '/': {
                    if (entryC) {
                        const c = (0, getNumberFromUnknown_1.default)(entryC);
                        if (c === 0) {
                            throw new Error('Cannot divide by 0 [C]');
                        }
                        const entryResult = newEntryValues
                            .reduce((acum, value, index) => {
                            if (index === 0 && acum === 0) {
                                return value;
                            }
                            return acum / value;
                        }, a / b / c);
                        return entryResult;
                    }
                    if (b === 0) {
                        throw new Error('Cannot divie by 0 [B]');
                    }
                    const entryResult = newEntryValues
                        .reduce((acum, value, index) => {
                        if (index === 0 && acum === 0) {
                            return value;
                        }
                        return acum / value;
                    }, a / b);
                    return entryResult;
                }
                default:
                    throw new Error(`Invalid operator [${operator}]`);
            }
        };
        const resultValue = result();
        /* Return and execute result. */
        executeProcesses(functionId, callbacks.onResult, resultValue);
        return resultValue;
    }
    catch (error) {
        const errorMessage = (0, getValueByPathFromUnknown_1.default)(error, ['message']);
        processor.root.alert('Aritmetic error:', `${errorMessage}`);
    }
    return undefined;
};
exports.default = arithmeticOperation;
